/**
 * Shared AI provider display constants.
 *
 * Used by:
 *   - src/routes/organization/AISettings.tsx (org-scoped panel)
 *   - src/routes/admin/PlatformAISettings.tsx (super-admin platform panel)
 *   - src/components/ai/AIProviderForm.tsx (shared form)
 *
 * Keep this list aligned with PROVIDER_CAPABILITIES in
 * server/modules/ai-config/ai-config.types.ts.
 */

export const PROVIDER_LABELS: Record<string, string> = {
  openai: 'OpenAI',
  anthropic: 'Anthropic',
  gemini: 'Google Gemini',
};

export const PROVIDER_ICONS: Record<string, string> = {
  openai: '🤖',
  anthropic: '🧠',
  gemini: '✨',
};
